import type * as SchemaTypes from '../types';

import type { DealerDisclaimersConfiguratorDataFragment } from './DealerPriceDisclaimerConfiguratorData';
import type { TranslatedStringDataFragment } from './TranslatedStringData';
import { gql } from '@apollo/client';
import { DealerDisclaimersConfiguratorDataFragmentDoc } from './DealerPriceDisclaimerConfiguratorData';
import { TranslatedStringDataFragmentDoc } from './TranslatedStringData';
export type InsurerEntrypointContextDataFragment = (
  { __typename: 'Insurer' }
  & Pick<SchemaTypes.Insurer, 'id' | 'displayName' | 'showCommentsField'>
  & { insuranceDisclaimer?: SchemaTypes.Maybe<(
    { __typename: 'DealerDisclaimersConfigurator' }
    & DealerDisclaimersConfiguratorDataFragment
  )>, integration: (
    { __typename: 'EazyInsurerIntegration' }
    & Pick<SchemaTypes.EazyInsurerIntegration, 'provider'>
  ) | (
    { __typename: 'EmailInsurerIntegration' }
    & Pick<SchemaTypes.EmailInsurerIntegration, 'provider'>
  ), insuranceProducts: Array<(
    { __typename: 'InsuranceProduct' }
    & Pick<SchemaTypes.InsuranceProduct, 'id' | 'displayName' | 'type'>
  )> }
);

export const InsurerEntrypointContextDataFragmentDoc = /*#__PURE__*/ gql`
    fragment InsurerEntrypointContextData on Insurer {
  id
  displayName
  insuranceDisclaimer {
    ...DealerDisclaimersConfiguratorData
  }
  integration {
    provider
  }
  showCommentsField
  insuranceProducts {
    id
    displayName
    type
  }
}
    `;